import React, { useState } from 'react';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import './carrossel.css';

import { Especialidade } from '../../components';

const SLIDE_WIDTH = 16.666;
const TOTAL_SLIDES = 6;

const Carrossel = ({ especialidades }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleMoveRight = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % TOTAL_SLIDES);
  };

  const handleMoveLeft = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + TOTAL_SLIDES) % TOTAL_SLIDES);
  };

  const sliderTransform = `translateX(${currentSlide * -SLIDE_WIDTH}%)`;

  return (
    <div className="container">
      <div className="carousel">
        <div className="slider" style={{ transform: sliderTransform }}>
          {especialidades.map((especialidade, index) => (
            <section key={especialidade.id}>
              <Especialidade
                titulo={especialidade.titulo}
                imagemSrc={especialidade.imagemSrc}
                texto={especialidade.texto}
              />
            </section>
          ))}
        </div>
        <div className="controls">
          <span className="arrow left" onClick={handleMoveLeft}>
            <IoChevronBack style={{ fontSize: '40px' }} />
          </span>
          <span className="arrow right" onClick={handleMoveRight}>
            <IoChevronForward style={{ fontSize: '40px' }} />
          </span>
        </div>
      </div>
    </div>
  );
};
export default Carrossel
